/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_UkrainianInputs */



/**
* | output |
* | --- |
* | "Ukrainian" |
*
* @param {Speechmatics_Target_Language_UkrainianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_ukrainian = /** @type {((inputs?: Speechmatics_Target_Language_UkrainianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_UkrainianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ukrainien")
	if (locale === "de") return /** @type {LocalizedString} */ ("ukrainisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("ucraino")
	if (locale === "ru") return /** @type {LocalizedString} */ ("украинский")
	if (locale === "es") return /** @type {LocalizedString} */ ("ucranio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("乌克兰")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ウクライナ語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यूक्रेनी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ucraniano")
	return /** @type {LocalizedString} */ ("Ukrainian")
});